import {SearchOptionsRequest} from '../../../../../../../shared/models/SearchOptionsRequest.model';
import {LpInterest} from '../../../../../../models/lpInterest.enum';

export class EngagementSearchRequest extends SearchOptionsRequest {
  holdingId: number;
  fundraisingId: number;
  responseFilter: LpInterest;
}
